const image = [
  {
    id: 0,
    image: 'dry-skin.jpg'
  },
  {
    id: 1,
    image: 'atopic.jpg'
  },
  {
    id: 2,
    image: 'microbiome.jpg'
  },
  {
    id: 3,
    image: 'acne.jpg'
  },
  {
    id: 4,
    image: 'rosacea.jpg'
  },
  {
    id: 5,
    image: 'psoriasis.jpg'
  },
  {
    id: 6,
    image: 'allergy.jpg'
  }
]

export default image
